import { useClientConfigProvider } from "@/app/config/client-config-provider";
import LandingV1 from "./v1/v1";
import LandingV2 from "./v2/v2";
import isLoggedIn from "@/app/redirect";

function LandingPage() {
  const { config } = useClientConfigProvider();
  if (config?.designVersion === "v1") {
    return <LandingV1 />;
  }
  if (config?.designVersion === "v2") {
    return <LandingV2 />;
  }
}

export default isLoggedIn(LandingPage);
